import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, {defaultSchema} from 'rehype-sanitize';
import {Box} from '@mui/material';

const markdownSanitizeSchema = {
    ...defaultSchema,
    attributes: {
        ...defaultSchema.attributes,
        span: [...(defaultSchema.attributes?.span ?? []), 'style'],
    },
};

const ChangelogMarkdown = ({children}) => {
    return (
        <Box
            sx={{
                '& p': {m: 0, mb: 1.5, lineHeight: 1.5},
                '& ul, & ol': {mt: 0, mb: 1.5, pl: 3},
                '& li': {mb: 0.5},
                '& img': {maxWidth: '100%', borderRadius: '8px', border: '1px solid rgba(0, 0, 0, 0.12)'},
                '& h2': {fontSize: '1.1rem', fontWeight: 600, mt: 2, mb: 1},
                '& strong': {fontWeight: 700},
                '& blockquote': {
                    m: 0,
                    mb: 1.5,
                    pl: 2,
                    borderLeft: '3px solid rgba(0, 0, 0, 0.12)',
                    color: 'text.secondary',
                },
            }}
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw, [rehypeSanitize, markdownSanitizeSchema]]}
            >
                {children}
            </ReactMarkdown>
        </Box>
    );
};

export default ChangelogMarkdown;
